// The 16 pictures for the K-5 picture PIN (numbered 0-15, a 4 x 4 grid; a PIN is 4 different pictures in order,
// 43,680 possible PINs). The numbers are what the server stores. Keep this list in the same order as the
// server expects (0-15): never reorder or replace a picture, or printed cards stop matching. 12-15 were added in
// round 3; 0-11 kept their numbers, so no card printed earlier changes.
export const KID_PICTURES = [
  { id: 0, emoji: "🍎", en: "apple", es: "manzana" },
  { id: 1, emoji: "⭐", en: "star", es: "estrella" },
  { id: 2, emoji: "☀️", en: "sun", es: "sol" },
  { id: 3, emoji: "🐶", en: "dog", es: "perro" },
  { id: 4, emoji: "🐱", en: "cat", es: "gato" },
  { id: 5, emoji: "🐟", en: "fish", es: "pez" },
  { id: 6, emoji: "🌳", en: "tree", es: "árbol" },
  { id: 7, emoji: "🌙", en: "moon", es: "luna" },
  { id: 8, emoji: "❤️", en: "heart", es: "corazón" },
  { id: 9, emoji: "🚗", en: "car", es: "carro" },
  { id: 10, emoji: "🌸", en: "flower", es: "flor" },
  { id: 11, emoji: "⚽", en: "ball", es: "pelota" },
  { id: 12, emoji: "🏠", en: "house", es: "casa" },
  { id: 13, emoji: "🐦", en: "bird", es: "pájaro" },
  { id: 14, emoji: "⛵", en: "boat", es: "barco" },
  { id: 15, emoji: "🐸", en: "frog", es: "rana" },
] as const;

export const KID_PIN_LENGTH = 4;

export function kidPicture(id: number) {
  return KID_PICTURES[id] ?? KID_PICTURES[0];
}
